/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x5a9fc7 from'./../../message.js';class ConnectMessage extends _0x5a9fc7{constructor(_0x338392){super(),this['documentId']=_0x338392;}['toJSON'](){return{'documentId':this['documentId']};}static['fromJSON'](_0x2de472){return new ConnectMessage(_0x2de472['documentId']);}}ConnectMessage['TYPE']='105',ConnectMessage['READABLE_TYPE_NAME']='connectToSuggestions',ConnectMessage['DESCRIPTOR_NAME']='TrackChangesConnectMessage',ConnectMessage['DESCRIPTOR']={'fields':{'documentId':{'type':'string','id':0x1}}};export default ConnectMessage;